module.exports = __webpack_public_path__ + "static/media/resultats_sapin2019.4b02063c.pdf";